import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authData, setAuthData] = useState({
    token: null,
    fullname: null,
    account: null,
    phoneNumber: null,
    role: null,
    isAuthenticated: false,
    isLoading: true,
  });

  useEffect(() => {
    // Load auth data from localStorage on mount
    const token = localStorage.getItem("token");
    const fullname = localStorage.getItem("fullname");
    const account = localStorage.getItem("account");
    const phoneNumber = localStorage.getItem("phoneNumber");
    const role = localStorage.getItem("role");

    setAuthData({
      token,
      fullname,
      account,
      phoneNumber,
      role,
      isAuthenticated: !!token,
      isLoading: false,
    });
  }, []);

  const signIn = ({ token, fullname, account,phoneNumber, role }) => {
    localStorage.setItem("token", token);
    localStorage.setItem("fullname", fullname);
    localStorage.setItem("account", account);
    localStorage.setItem("phoneNumber", phoneNumber);
    localStorage.setItem("role", role);
    setAuthData({ token, fullname, account,phoneNumber, role, isAuthenticated: true, isLoading: false });
  };

  const signOut = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("fullname");
    localStorage.removeItem("account");
    localStorage.removeItem("phoneNumber");
    localStorage.removeItem("role");
    setAuthData({
      token: null,
      fullname: null,
      account: null,
      phoneNumber: null,
      role: null,
      isAuthenticated: false,
      isLoading: false,
    });
  };

  return (
    <AuthContext.Provider value={{ ...authData, signIn, signOut }}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook for using AuthContext
export const useAuth = () => useContext(AuthContext);
